import { Link } from "react-router-dom";

const footerLinks = [
  { en: "Home", ja: "ホーム", path: "/" },
  { en: "About", ja: "私たちについて", path: "/about" },
  { en: "Talent", ja: "所属タレント", path: "/talent" },
  { en: "Talent Management", ja: "タレントマネジメント事業", path: "/entertainment" },
  { en: "Farm", ja: "ファーム事業", path: "/farm" },
  { en: "EC", ja: "ネットショップ", path: "/ec", external: "https://olcompany.base.shop/" },
  { en: "Company", ja: "会社概要", path: "/company" },
  { en: "News", ja: "ニュース", path: "/news" },
  { en: "Policy", ja: "プライバシーポリシー", path: "/privacy" },
];

export default function Footer() {
  return (
    <footer className="bg-zinc-900 text-white pt-14 md:pt-28 pb-8">
      <div className="px-5 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between gap-8 md:gap-10 mb-8 md:mb-10">
          {/* Logo & description */}
          <div className="flex flex-col gap-4 md:gap-5">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/94de9ad61a818f19b5b00b45a7353c61.webp"
                alt="OL Company"
                className="h-[40px] md:h-[84px] w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="hidden md:block text-lg text-zinc-400 leading-relaxed max-w-xs">
              ローカルの輝きを世界とシェアする。<br />
              大分から、新しい価値を創造しつづけます。
            </p>
            <div className="flex items-center gap-4 md:gap-5">
              <a
                href="https://www.instagram.com/olcompany_inc/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center border border-zinc-700 text-zinc-400 hover:text-white hover:border-white transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg md:text-xl" />
              </a>
              <a
                href="https://www.youtube.com/@O.L.C"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center border border-zinc-700 text-zinc-400 hover:text-white hover:border-white transition-colors cursor-pointer"
              >
                <i className="ri-youtube-line text-lg md:text-xl" />
              </a>
            </div>
            <Link to="/contact" className="inline-block text-sm md:text-xl text-zinc-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              お問い合わせ
            </Link>
          </div>

          {/* Nav Links */}
          <nav className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-4 gap-x-6 md:gap-x-12 gap-y-4 md:gap-y-6 lg:mr-[10%]">
            {footerLinks.map((item) => {
              if (item.external) {
                return (
                  <a
                    key={item.en}
                    href={item.external}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-col cursor-pointer group"
                  >
                    <span className="text-sm md:text-lg font-semibold tracking-wider text-white group-hover:text-zinc-300 transition-colors leading-tight md:whitespace-nowrap">{item.en}</span>
                    <span className="text-xs md:text-[15px] text-zinc-500 mt-0.5 leading-tight md:whitespace-nowrap">{item.ja}</span>
                  </a>
                );
              }
              return (
                <Link key={item.en} to={item.path} className="flex flex-col group cursor-pointer">
                  <span className="text-sm md:text-lg font-semibold tracking-wider text-white group-hover:text-zinc-300 transition-colors leading-tight md:whitespace-nowrap">{item.en}</span>
                  <span className="text-xs md:text-[15px] text-zinc-500 mt-0.5 leading-tight md:whitespace-nowrap">{item.ja}</span>
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="border-t border-zinc-800 pt-4 md:pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs md:text-base text-zinc-500">© 2023 OLCompany Inc All Right Reserved.</p>
        </div>
      </div>
    </footer>
  );
}